import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Deliverability from '@/pages/deliverability';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Deliverability} />
    </Switch>
  );
}
